import React, { createContext, useState, useContext } from 'react';
import { getRequest } from 'utils/request';

const ModalContext = createContext({});

const ModalProvider = ({ children }) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [modalPhotoVisible, setModalPhotoVisible] = useState(false);
    const [data, setData] = useState({});
    const [photoData, setPhotoData] = useState({});
    const [loading, setLoading] = useState();
    const [helperId, setHelperId] = useState('');
    const [loadingModal, setLoadingModal] = useState(false);
    const [status, setStatus] = useState("");
    const [ignoreQr, setIgnoreQr] = useState(false);
    const [disconnectedModalVisible, setDisconnectedModalVisible] = useState(false);
    const [reconnect, setReconnect] = useState(0);

    const toggleModal = (id) => {
        setLoading(true);
        setModalVisible(!modalVisible);
        getRequest(`/helps/${id}`).then((resp) => {
            setData(resp.data)
        });
        setTimeout(() => {
            setLoading(false);
        }, 500)
    }

    const togglePhotoModal = (data) => {
        setModalPhotoVisible(true);
        setPhotoData(data);
    }

    const toggleHelperId = (id) => {
        setHelperId(id);
    }

    const toggleReconnect = () => {
      setReconnect(reconnect + 1)
    }


    return (
        <ModalContext.Provider
            value={{
                modalVisible,
                setModalVisible,
                toggleModal,
                data,
                loading,
                modalPhotoVisible,
                setModalPhotoVisible,
                photoData,
                togglePhotoModal,
                helperId,
                toggleHelperId,
                loadingModal,
                setLoadingModal,
                status,
                setStatus,
                ignoreQr,
                setIgnoreQr,
                disconnectedModalVisible,
                setDisconnectedModalVisible,
                toggleReconnect,
                reconnect
            }}
        >
            {children}
        </ModalContext.Provider>
    )
};

function useModal(){
    const context = useContext(ModalContext);

    if (!context) {
        throw new Error('useModal must be used within an ModalProvider');
    }

    return context;
}

export { ModalProvider, useModal };

